import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Features from "../../components/Features/Features";
import Idcard from "../../components/Idcard/Idcard";
import Spinner from "../../components/UI/Spinner/Spinner";
import Introduction from "../../components/Introduction/Introduction";
import MyFavorites from "../../containers/FindProvider/Search/MyFavorites/MyFavorites";
import { logFirebaseEvent } from "../../shared/utility";
import * as homeActions from "../../store/actions/";
// import NetworkDetector from "../../hoc/NetworkDetector/NetworkDetector";
import Modal from "../../components/UI/Modal/Modal";
import NetworkAlert from "../../components/UI/NetworkAlert/NetworkAlert";
import classes from "./Home.module.css";

interface IStateFromProps {
  appConfig: {
    modules: string[];
    theme: string;
  };
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  error: boolean;
  loading: boolean;
  parseAccessTokenLoading: boolean;
  accessTokenParsed: boolean;
  loadingDrexi: boolean;
  errorDrexi: boolean;
  erroeMessageDrexi: string;
  t: any;
}
interface IDispatchFromProps {
  onParsingAccessToken: () => void;
  onResetSearchParam: () => void;
  onRemoveExplanationOfBenefitsFiles: (fileArray: File[]) => void;
  onRemoveProviderBillsFiles: (fileArray: File[]) => void;
  onRemovePatientsResponsibilityFiles: (fileArray: File[]) => void;
  onResetDisputeAuthorizationFile: () => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
  onShouldUploadDocument: (shouldUpload: boolean) => void;
  onGetUserImpersonation: (userId: string) => void;
}

type Props = IStateFromProps & IDispatchFromProps;

class Home extends Component<Props> {
  state = {
    modules:
      localStorage.getItem("modulesConfig") &&
      localStorage.getItem("modulesConfig") !== ""
        ? localStorage.getItem("modulesConfig")?.split(",")
        : [],

    errorDrexi: false,
  };
  componentDidMount() {
    logFirebaseEvent("Home");
    this.props.onResetSearchParam();
    this.props.onSetBalanceBillViewState("notGetStarted");
    this.props.onRemoveProviderBillsFiles([]);
    this.props.onRemovePatientsResponsibilityFiles([]);
    this.props.onRemoveExplanationOfBenefitsFiles([]);
    this.props.onResetDisputeAuthorizationFile();
    this.props.onShouldUploadDocument(false);
    let userId = localStorage.getItem("userId");
    if (userId != null) {
      this.props.onGetUserImpersonation(userId);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("componentDidUpdate in Home");
    console.log("accessTokenParsed", this.props.accessTokenParsed);
    console.log("accessTokenParsed", prevProps.accessTokenParsed);

    if (this.props.accessTokenParsed !== prevProps.accessTokenParsed) {
      let userId = localStorage.getItem("userId");
      if (userId != null) {
        console.log("vikas", userId);
        this.props.onGetUserImpersonation(userId);
      }
      this.setState({
        modules:
          localStorage.getItem("modulesConfig") &&
          localStorage.getItem("modulesConfig") !== ""
            ? localStorage.getItem("modulesConfig")?.split(",")
            : [],
      });
    }
    const { appConfig } = this.props;
    if (
      JSON.stringify(prevProps.appConfig) !== JSON.stringify(appConfig) &&
      appConfig
    ) {
      // commented the line because of modules from token
      // const { modules, theme } = appConfig;
      const { theme } = appConfig;
      // update the body id to set the theme
      if (document.body.id !== theme) {
        document.body.id = theme;
      }
      // update state with the latest modules for features display
      // commented the line because of modules from token
      // if (Array.isArray(modules) && modules.length > 0)
      //   this.setState({ modules });
    }

    if (prevProps.errorDrexi !== this.props.errorDrexi) {
      this.setState({ errorDrexi: this.props.errorDrexi });
    }
  }

  closeDisplayErrorMessage = () => {
    this.setState({ errorDrexi: false });
    // window.open("https://drexi.com/enroll")
  };
  render() {
    const { t } = this.props;
    const btnStyle = {
      width: "460px",
      left: "calc(50% - 230px)",
    };
    console.log("this.props.appConfig", this.props.appConfig);
    console.log("this.state.modules", this.state.modules);
    let fetchingConfig: any;
    // if (this.props.parseAccessTokenLoading || this.props.loading) {
    //   fetchingConfig = <Spinner />;
    // }
    let modulesList: any;
    // if (this.state.modulesName.length > 0) {
    if (this.state.modules) {
      console.log("rendering features again");
      modulesList = (
        <div className={classes.rowSpace}>
          <Features t={t} featuresList={this.state.modules} />
        </div>
      );
    }

    let myFavorites: any;
    if (
      this.state.modules &&
      this.state.modules.findIndex((module) => module === "My Favorites") !== -1
    ) {
      myFavorites = (
        <div>
          <h3 className={classes.mdTitle}>{t("menuBar.myFavorite")}</h3>
          <div className="myFavorites">
            <MyFavorites mapDisplay={false} />
          </div>
        </div>
      );
    }
    let spinner: any;
    if (this.props.loadingDrexi) {
      spinner = <Spinner />;
    }

    let displayErrorMessage: any;
    if (this.props.errorDrexi) {
      // console.log("displayErrorMessage");
      displayErrorMessage = (
        <Modal
          show={this.state.errorDrexi}
          childComp={
            <NetworkAlert
              modalClosed={this.closeDisplayErrorMessage}
              error={this.props.erroeMessageDrexi}
            />
          }
          style={btnStyle}
        />
      );
    }
    return (
      <Container fluid>
        {spinner}
        {fetchingConfig}
        {displayErrorMessage}
        <div className={classes.rowTop}>
          <Introduction
            introText={
              this.props.config_values &&
              this.props.config_values.find(
                (ele) =>
                  ele.targetPageTitle.toLowerCase() === "Home".toLowerCase() &&
                  ele.element.toLowerCase() === "Welcome Text".toLowerCase()
              )
                ? this.props.config_values.find(
                    (ele) =>
                      ele.targetPageTitle.toLowerCase() ===
                        "Home".toLowerCase() &&
                      ele.element.toLowerCase() === "Welcome Text".toLowerCase()
                  )?.customValue
                  ? this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Home".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Welcome Text".toLowerCase()
                    )?.customValue
                  : this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Home".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Welcome Text".toLowerCase()
                    )?.defaultValue
                : ``
            }
          />
        </div>
        {modulesList}
        <div className={classes.rowSpace}>
          <Row>
            <Col sm={12} md={4}>
              <div className={classes.cardLeft}>
                <h3 className={classes.mdTitle}>{t("homePage.theMoreTxt")}</h3>
                <Idcard
                  t={t}
                  moreYouKnow1={
                    this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Home".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "More you know - 1".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Home".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "More you know - 1".toLowerCase()
                        )?.customValue
                        ? this.props.config_values.find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "Home".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "More you know - 1".toLowerCase()
                          )?.customValue
                        : this.props.config_values.find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "Home".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "More you know - 1".toLowerCase()
                          )?.defaultValue
                      : `https://ampsweb-dev.azurewebsites.net/static/media/Billing-Errors.ec80310d.png`
                  }
                  moreYouKnow2={
                    this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Home".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "More you know - 2".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Home".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "More you know - 2".toLowerCase()
                        )?.customValue
                        ? this.props.config_values.find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "Home".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "More you know - 2".toLowerCase()
                          )?.customValue
                        : this.props.config_values.find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "Home".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "More you know - 2".toLowerCase()
                          )?.defaultValue
                      : `https://ampsweb-dev.azurewebsites.net/static/media/Patient-Responsibility.134c0cb3.png`
                  }
                />
              </div>
            </Col>
            <Col sm={12} md={8}>
              {this.props.accessTokenParsed && (
                <div className={classes.cardRight}>{myFavorites}</div>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}
const mapStateToProps = (state: any) => ({
  appConfig: state.appConfig.appConfig,
  config_values: state.appConfig.config_values,
  error: state.appConfig.error,
  loading: state.appConfig.loading,
  parseAccessTokenLoading: state.parseAccessToken.parseAccessTokenLoading,
  accessTokenParsed: state.parseAccessToken.accessTokenParsed,
  loadingDrexi: state.drexiLogin.loading,
  errorDrexi: state.drexiLogin.error,
  erroeMessageDrexi: state.drexiLogin.errorMessage,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onParsingAccessToken: () => dispatch(homeActions.parseAccessToken()),
  onResetSearchParam: () => dispatch(homeActions.resetSearchParam()),
  onRemoveExplanationOfBenefitsFiles: (explanationOfBenefitsBills) =>
    dispatch(
      homeActions.explanationOfBenefitsBills(explanationOfBenefitsBills)
    ),
  onRemoveProviderBillsFiles: (providerBills) =>
    dispatch(homeActions.providerBills(providerBills)),
  onRemovePatientsResponsibilityFiles: (patientsResponsibilityBills) =>
    dispatch(
      homeActions.patientsResponsibilityBills(patientsResponsibilityBills)
    ),
  onGetUserImpersonation: (userId) =>
    dispatch(homeActions.fetchCanUserImpersonate(userId)),
  onResetDisputeAuthorizationFile: () =>
    dispatch(homeActions.resetDisputeAuthorizationFile()),
  onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(homeActions.setBalanceBillViewState(balanceBillView)),
  onShouldUploadDocument: (shouldUplaod) =>
    dispatch(homeActions.shouldUploadDocument(shouldUplaod)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Home));
